import { MarkdownV2 } from 'components/common/MarkdownV2'

interface Props {
  children: string
}

export function MarkdownContent({ children }: Props) {
  return (
    <MarkdownV2
      overrides={{
        h2: {
          props: {
            className:
              'tracking-normal font-body text-xl font-medium mb-2 sm:text-2xl',
          },
        },
        a: {
          props: {
            className: 'text-secondary-default underline font-medium',
            target: '_blank',
          },
        },
        p: {
          props: {
            className: 'leading-6 text-cool-800 [&:not(:last-of-type)]:mb-6',
          },
        },
      }}
    >
      {children}
    </MarkdownV2>
  )
}
